import { Product, ProductRateData } from '@/network/graphql.g'
import { FC } from 'react'
import { Box, Flex } from '../../atoms/Grid'
import { Body2 } from '../../atoms/typography'
import RatingInfoIcon from '../../molecules/ratingInfoIcon'
import { ListItemSeparator } from '@/components/atoms/separator'
import AdditionalRatingInfo from './additionalRatingInfo'
import StarRatingContainer from './starRatingContainer'
import Reviews from './reviews'
import styled, { css, useTheme } from 'styled-components'
import { ArrowDownIconDefault } from '@/components/atoms/icons/ArrowDownIconDefault'
import useTranslation from 'next-translate/useTranslation'
import { validFor } from '@/theme/validFor'

type ProductDetailRatingProps = {
  isExpanded: boolean
  handleChange: () => void
  product: Product
  productRateData: ProductRateData
}

const ProductDetailRating: FC<ProductDetailRatingProps> = ({
  isExpanded,
  handleChange,
  product,
  productRateData
}) => {
  const { t } = useTranslation('common')
  const theme = useTheme()

  return (
    <Box>
      <StyledFlex onClick={handleChange}>
        <StyledDownIcon isExpanded={isExpanded} />
        <Body2 mr={3}>{t('ProductDetail.Reviews.title')}</Body2>
        <RatingInfoIcon
          productRateData={productRateData}
          marginTop={2}
          fillColor={theme.colors.sizeTableDescription}
        />
      </StyledFlex>
      <ListItemSeparator mb={24} />
      <ExpandableContainer isExpanded={isExpanded}>
        <StarRatingContainer productRateData={productRateData} />
        <AdditionalRatingInfo rateTypeData={productRateData?.rateTypeData} />
        <ListItemSeparator />
        <Reviews
          product={product}
          productRateData={productRateData}
          isExpanded={isExpanded}
        />
      </ExpandableContainer>
    </Box>
  )
}

export default ProductDetailRating

const StyledFlex = styled(Flex)`
  cursor: pointer;
`

const ExpandableContainer = styled(Box)`
  overflow: hidden;
  height: 0;
  opacity: 0;
  transition: all 0.3s ease-out;
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      height: 100%;
      opacity: 1;
    `}
  ${validFor.mobile`
    margin-inline: 14px;
`};
`

const StyledDownIcon = styled(ArrowDownIconDefault)`
  transition: all 0.3s ease-out;
  margin-right: 5px;
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: rotateZ(180deg);
      transform-origin: center;
    `};
`
